import React from 'react';
import './SidebarNews.css';
import {useDispatch} from 'react-redux';
import FiberManualRecordIcon  from '@material-ui/icons/FiberManualRecord';
import {setNewsInfo} from './features/newsSlice';

function SidebarNews({id, newsName}) {
    const dispatch = useDispatch();
    return (
        <div className="sidebarNews" 
        onClick={() => 
        dispatch (
        setNewsInfo({
            newsId: id,
            newsName: newsName,
            })
            )
            }
        >
            <h4>
                <FiberManualRecordIcon className="sidebarNews__record"/>
                {newsName}
            </h4>
        </div>
    )
}

export default SidebarNews
